import { usePageProperties } from 'hooks/usePageProperies'

export const useSiteEmail = () => {
  const { siteEmail } = usePageProperties()
  return siteEmail
}
